/* eslint-disable import/prefer-default-export */
import { AppThunk } from '€slices/types';
import { actions as formEntryActions } from '€slices/form-entry';

export const resetUserData = (): AppThunk => async dispatch => {
    dispatch(formEntryActions.reset());
};
